import { Commodity } from "../components/CItem";

export const commodities: Commodity[] = [
  {
    name: "Fruit",
    rank: 2,
    post: {
      title: "Russian official wants ban on vegetarianism for children",
      description:
        "Plant-based and raw food diets are \u2018unacceptable\u2019 for children, a Russian official has argued",
      url: "https://www.rt.com/russia/585271-russia-ban-vegetarianism-children/",
      imgURL:
        "https://mf.b37mrtl.ru/files/2023.10/article/652ff2b32030275be81b5196.jpg",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      -1.5612903225806452, 2.867857142857143, 7.916129032258064,
      11.706666666666669, 19.81290322580645, 23.58, 26.016129032258064,
      25.89516129032258, 20.265, 13.146774193548389, 9.143333333333334,
      2.012903225806451, 5.174193548387097,
    ],
    productions: [
      1220064580.3505669, 2241076416.6666665, 6186029917.727875,
      9148131611.014254, 15482720356.432194, 18426504275.716064,
      20330208348.19695, 20235678551.165653, 15836009717.870483,
      10273498341.361025, 7145024205.299572, 1572975822.600731,
      4043354518.35188,
    ],
    prices: [
      150.4, 154.8, 149.4, 147.6, 150.9, 154.1, 147.2, 140.5, 132.0, 139.4,
      154.0, 161.6, 150.4,
    ],
  },
  {
    name: "Fish",
    rank: 1,
    post: {
      title:
        "'Confused' angler calls dad after catching odd fish. It tied a state record in Georgia",
      description:
        "The 20-year-old saw the fish's yellow color and got “really excited,” Georgia wildlife officials said.",
      url: "https://news.yahoo.com/confused-angler-calls-dad-catching-185304858.html",
      imgURL:
        "data:image/jpeg;base64,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",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      11.34516129032258, 14.155357142857143, 18.075806451612905,
      22.298333333333336, 26.991666666666667, 29.898333333333333,
      29.11774193548387, 28.556451612903224, 27.58, 21.77258064516129,
      17.491666666666667, 14.870967741935484, 16.072131147540983,
    ],
    productions: [
      15058.522727272728, 18788.518011656743, 23992.16153035904,
      29596.75501191185, 35826.25363763453, 39684.29540015596,
      38648.21023535038, 37903.20513027632, 36607.15314575956,
      28898.919291364033, 23216.828152329384, 19738.353645927575,
      21332.66737841788,
    ],
    prices: [
      132.7, 139.5, 140.6, 141.2, 143.5, 126.2, 124.4, 124.3, 126.5, 126.4,
      125.3, 125.2, 132.7,
    ],
  },
  {
    name: "Vegetables",
    rank: 6,
    post: {
      title:
        "How to use ethylene absorbers to keep fruits and vegetables fresh - The Washington Post",
      description:
        "Ethylene absorbers can pull the naturally occurring plant hormone that drives ripening from the air and hold onto it.",
      url: "https://www.washingtonpost.com/climate-solutions/2024/02/25/ethylene-absorber-fruit-vegetables-fresh/",
      imgURL:
        "data:image/jpeg;base64,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",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      11.429032258064517, 12.305357142857144, 14.158064516129032,
      15.066666666666666, 17.845161290322583, 21.66, 21.580645161290324,
      22.595161290322583, 23.035, 17.7241935483871, 11.001666666666669,
      9.638709677419357, 10.091935483870968,
    ],
    productions: [
      437404966.6666666, 470943139.31041086, 541848828.3093423,
      576622296.8231566, 682959152.0180638, 828958337.3355912,
      825921317.2452723, 864748261.0828865, 881581500.4859345,
      678329548.2218459, 421049090.8550507, 368886830.4826419,
      386232412.7058048,
    ],
    prices: [
      82.1, 82.1, 83.2, 84.6, 85.4, 87.4, 92.5, 96.1, 96.4, 100.7, 119.0, 124.8,
      82.1,
    ],
  },
  {
    name: "Nuts",
    rank: 4,
    post: {
      title: "Children celebrate traditional full moon holiday with nuts",
      description:
        "Children crack bureom, or nuts, a tradition during the Jeongwol Daeboreum holiday, at a kindergarten for kids whose parents are employees at",
      url: "https://koreajoongangdaily.joins.com/news/2024-02-22/business/economy/Children-celebrate-traditional-full-moon-holiday-with-nuts/1986995",
      imgURL:
        "data:image/jpeg;base64,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",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      11.429032258064517, 12.305357142857144, 14.158064516129032,
      15.066666666666666, 17.845161290322583, 21.66, 21.580645161290324,
      22.595161290322583, 23.035, 17.7241935483871, 11.001666666666669,
      9.638709677419357, 10.091935483870968,
    ],
    productions: [
      5247962.875, 5650352.19003455, 6501075.094093988, 6918285.427086272,
      8194109.687976291, 9945800.598497037, 9909362.58361558,
      10375206.310453711, 10577170.67342471, 8138563.933583829,
      5051725.8964819135, 4425885.709991533, 4633997.136448631,
    ],
    prices: [
      63.3, 58.2, 58.3, 60.3, 59.4, 58.4, 57.9, 57.2, 55.8, 54.0, 53.3, 52.7,
      63.3,
    ],
  },
  {
    name: "Soybeans",
    rank: 5,
    post: {
      title:
        "Why Animal/Dental Health Focused Patterson Companies (PDCO) Shares Are Falling Today - Patterson Cos (NASDAQ:PDCO)",
      description:
        "Patterson Companies Inc\u00a0(NASDAQ: PDCO) reported Q2 FY24 net sales of $1.65 billion, up 1.6% Y/Y, missing the",
      url: "https://www.benzinga.com/news/earnings/23/11/36001547/animaldental-health-focused-patterson-cuts-annual-guidance-amid-inflationary-pressures",
      imgURL:
        "https://cdn.benzinga.com/files/images/story/2023/11/29/pdco_1.png?width=1200&height=800&fit=crop",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      -4.869354838709677, -3.566071428571429, 3.2225806451612904,
      8.639999999999999, 16.488709677419354, 22.926666666666662,
      24.92419354838709, 23.537096774193547, 20.043333333333333, 11.45,
      1.3649999999999998, -6.432258064516129, -5.837096774193548,
    ],
    productions: [
      71714385.41666667, 106169061.2361111, 6105109.35, 13306841.55, 2240966.05,
      16000870.55, 40924111.81666667, 14549608.916666668, 23093729.166666664,
      14789416.883333337, 76749952.2, 16211629.366666663, 71714385.41666667,
    ],
    prices: [
      277.6, 305.9, 329.2, 322.6, 330.7, 339.6, 315.6, 319.0, 309.2, 288.9,
      306.7, 296.6, 277.6,
    ],
  },
  {
    name: "Animal Products",
    rank: 3,
    post: {
      title:
        "Bill Gates says fake meat products will \u2018eventually\u2019 be \u2018very good\u2019",
      description:
        'Microsoft co-founder turned\u00a0billionaire philanthropist\u00a0Bill Gates\u00a0said he is hopeful that fake meat products will eventually be a "very good" option for cons...',
      url: "https://nypost.com/2023/01/15/bill-gates-says-fake-meat-products-will-eventually-be-very-good/",
      imgURL:
        "https://nypost.com/wp-content/uploads/sites/2/2023/01/newspress-collage-25372149-1673756975977.jpg?quality=75&strip=all&1673739013&w=1024",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      5.958620689655173, 7.337037037037037, 13.46551724137931,
      17.876785714285713, 23.41875, 27.36379310344828, 30.933333333333337,
      28.146774193548385, 25.053846153846152, 17.94333333333333,
      12.435185185185183, 10.201724137931036, 10.926666666666668,
    ],
    productions: [
      743986786.9886363, 916094311.6711016, 1681290027.272726,
      2232075642.282479, 2924039254.9260297, 3416612926.0556364,
      3862301833.440513, 3514374661.0127087, 3128196083.7069016,
      2240385057.922386, 1552642682.3806503, 1273775773.6531105,
      1364291888.113535,
    ],
    prices: [
      216.1, 218.0, 217.3, 221.2, 221.8, 220.4, 219.9, 217.1, 215.1, 215.0,
      211.8, 203.5, 216.1,
    ],
  },
  {
    name: "Wheat",
    rank: 8,
    post: {
      title:
        "A woolly mammoth meatball? Scientists grew prehistoric meat with extinct animal DNA",
      description:
        "A cell-based meat company resurrected the extinct woolly mammoth in the form of a lab-grown meatball.",
      url: "https://www.usatoday.com/story/news/world/2023/03/28/woolly-mammoth-meat-lab-grown/11554736002/",
      imgURL:
        "https://www.gannett-cdn.com/presto/2023/03/28/USAT/75b3abe3-80fb-4c05-ba24-09306ef788d8-Mammoth_Ball_01.jpg?auto=webp&crop=3999,2250,x0,y203&format=pjpg&width=1200",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      -1.220967741935484, -0.0607142857142857, 6.814516129032258,
      12.596551724137932, 18.98225806451613, 24.10333333333333,
      25.79516129032258, 25.53548387096774, 21.91166666666667,
      14.101612903225806, 5.601666666666668, -1.030645161290323,
      0.1532258064516129,
    ],
    productions: [
      20971632.324074075, 30922928.148148146, 9703767.175925927,
      7074746.481481481, 15964258.759259256, 8097940.552083333,
      15316238.802083334, 4970731.302083333, 6617350.552083333,
      6344122.145833334, 18182745.010416664, 6182631.84375, 20971632.324074075,
    ],
    prices: [
      322.1, 316.3, 394.5, 375.3, 390.4, 392.5, 311.3, 301.1, 307.0, 337.4,
      329.5, 304.8, 322.1,
    ],
  },
  {
    name: "Corn",
    rank: 7,
    post: {
      title:
        "Argentina's hoped-for record corn harvest threatened by sliding prices -exchange",
      description:
        "Corn exports from Argentina, the world's third biggest supplier, are expected to rise 53% compared to last season thanks to ample rainfall",
      url: "https://www.agriculture.com/argentina-s-hoped-for-record-corn-harvest-threatened-by-sliding-prices-exchange-8599532",
      imgURL:
        "data:image/jpeg;base64,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",
    },
    dates: [
      "2022-01-31",
      "2022-02-28",
      "2022-03-31",
      "2022-04-30",
      "2022-05-31",
      "2022-06-30",
      "2022-07-31",
      "2022-08-31",
      "2022-09-30",
      "2022-10-31",
      "2022-11-30",
      "2022-12-31",
      "2023-01-31",
    ],
    temps: [
      -4.869354838709677, -3.566071428571429, 3.2225806451612904,
      8.639999999999999, 16.488709677419354, 22.926666666666662,
      24.92419354838709, 23.537096774193547, 20.043333333333333, 11.45,
      1.3649999999999998, -6.432258064516129, -5.837096774193548,
    ],
    productions: [
      132788391.33333334, 216234377.4916667, 10002341.325, 23056726.225,
      4105422.1916666655, 24892385.433333337, 67840270.94166666, 25992395.5,
      39462907.84166666, 25901141.816666663, 127027354.40833332,
      29481888.916666668, 132788391.33333334,
    ],
    prices: [
      287.9, 300.4, 340.2, 353.7, 370.5, 349.7, 345.3, 327.4, 327.1, 331.8,
      353.0, 318.6, 287.9,
    ],
  },
];
